export default __webpack_public_path__ + "static/es-18bb17a85f90627dfeb114967fa69bbe.svg";